import moment from "moment";
import pluralize from "pluralize";
import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import Loading from "../../../../common/Loading";
import PrimaryBtn from "../../../../common/Buttons/PrimaryButton";
import { updateFeedBackDets } from "../../../../../redux/actions/shortlinkActions";
import { redirectToDifferentPage } from "../../../../../utils/constants/constants";

const FeedbackModal = ({
  isOpen,
  fbData,
  txnData,
  storeId,
  shortCode,
  activeStep,
  toggleModal,
  loyaltyData,
  currencyView,
  setActiveStep,
  pointsBranding,
  isLoyaltyActive,
  isProfileComplete,
  isCashbackLoyalty,
  hear_about_us_flag,
}) => {
  const dispatch = useDispatch();
  const [textFb, setTextFb] = useState("");
  // const [activeHover, setActiveHover] = useState(0);
  const [activeRating, setActiveRating] = useState(0);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedVisitedFrms, setSelectedVisitedFrms] = useState([]);
  const [isSubmitFirstStep, setSubmittingFirstStep] = useState(false);
  const [isSubmitSecondStep, setSubmittingSecondStep] = useState(false);

  const isOnlineReviewActive = fbData?.online_review?.is_active;
  const minRatingForReview = fbData?.online_review?.min_ratings[0];
  const reviewPlatform = fbData?.online_review?.review_links[0]?.source;
  const reviewDirectLink = fbData?.online_review?.review_links[0]?.link;
  const reviewShortCode = fbData?.online_review?.review_links[0]?.shortlink;

  const handleCategoryClick = (category) => {
    const indexOfCat = selectedCategories.findIndex((cat) => cat === category);
    if (indexOfCat === -1) {
      setSelectedCategories([...selectedCategories, ...[category]]);
    } else {
      const newSelectedCategories = [...selectedCategories];
      newSelectedCategories.splice(indexOfCat, 1);
      setSelectedCategories(newSelectedCategories);
    }
  };

  const handleVisitedFromClick = (visitFrm) => {
    setSubmittingSecondStep(true);
    dispatch(
      updateFeedBackDets(storeId, txnData?.id, {
        hear_about_us: [visitFrm.name],
      })
    )
      .then(() => {
        setActiveStep(2);
        setSubmittingSecondStep(false);
        if (
          isProfileComplete &&
          isLoyaltyActive &&
          !(
            isOnlineReviewActive &&
            activeRating >= minRatingForReview &&
            shortCode !== localStorage?.review_short_code_2 &&
            reviewShortCode !== localStorage.review_short_code
          )
        )
          setSelectedVisitedFrms([visitFrm.name]);
      })
      .catch(() => setSubmittingSecondStep(false));
  };

  const handleCopy = () => {
    navigator?.clipboard?.writeText(textFb);
    toastr.success("Success", "Comment Copied !!!");
  };

  const hostName =
    import.meta.env.VITE_CUSTOM_NODE_ENV === "production"
      ? "http://l.reelo.io"
      : import.meta.env.VITE_CUSTOM_NODE_ENV === "staging"
      ? "http://ls.reelo.io"
      : "http://ld.reelo.io";

  return (
    <Offcanvas
      show={isOpen}
      scroll={false}
      placement="bottom"
      onHide={toggleModal}
      className={`fb-shortlink-canvas${
        activeStep === 0 && activeRating !== 0 ? " fb-add-scroll-margin" : ""
      }`}
    >
      <div className="fb-shortlink-canvas-root">
        <img
          alt="close"
          title="Close"
          onClick={toggleModal}
          className="close-icon"
          src="/assets/icons/close-border-white.svg"
        />
        <div className="fb-shortlink-canvas-content">
          {activeStep === 0 && (
            <div className="first-fb-step">
              {activeRating === 0 && <h4>{fbData?.questions?.main}</h4>}
              <div className="rating-row">
                {fbData?.style === "emoji" &&
                  emojiIcons?.map((emoji, i) => (
                    <img
                      key={i}
                      src={emoji}
                      alt={`emoji-${i}`}
                      className={`emojis${
                        activeRating === 0
                          ? ""
                          : activeRating === i + 1
                          ? " selected-rating"
                          : " unselected-rating"
                      }`}
                      onClick={() => setActiveRating(i + 1)}
                    />
                  ))}

                {/* {fbData?.style === "rating" &&
                  [...Array(5)]?.map((_, i) => (
                    <div
                      key={i}
                      className={`star-rating${
                        activeHover === 0
                          ? ""
                          : i < activeHover
                          ? " selected-hover"
                          : ""
                      }${
                        activeRating === 0
                          ? ""
                          : i < activeRating
                          ? " selected-star-rating"
                          : ""
                      }`}
                      onClick={() => setActiveRating(i + 1)}
                      onMouseOver={() => setActiveHover(i + 1)}
                      onMouseLeave={() => setActiveHover(activeRating)}
                    >
                      <Star />
                    </div>
                  ))} */}

                {fbData?.style === "number" &&
                  scoreIcons?.map((score, i) => (
                    <img
                      key={i}
                      src={score}
                      alt={`emoji-${i}`}
                      className={`emojis${
                        activeRating === 0
                          ? ""
                          : activeRating === i + 1
                          ? " selected-rating"
                          : " unselected-rating"
                      }`}
                      onClick={() => setActiveRating(i + 1)}
                    />
                  ))}
              </div>
              {activeRating === 0 ? (
                <>
                  <h5>
                    <b>Purchase made</b>
                  </h5>
                  <div className="purchase-row">
                    <div className="purchase-col">
                      <h5>
                        {currencyView}
                        {txnData?.txn?.value}
                      </h5>
                    </div>
                    <div className="purchase-col">
                      <img src="/assets/icons/clock-2.svg" alt="clock" />
                      <h5>
                        {moment(txnData?.txn?.created_at)?.format(
                          "DD MMM YYYY, hh:mm a"
                        )}
                      </h5>
                    </div>
                  </div>
                  {fbData?.bonus?.status && (
                    <div className="bonus-card">
                      <img alt="Bonus" src="/assets/icons/lightning.svg" />
                      <h3>
                        Earn{" "}
                        <span>
                          {fbData?.bonus?.points} Bonus{" "}
                          {isCashbackLoyalty
                            ? pointsBranding?.active
                              ? pluralize(
                                  pointsBranding?.name,
                                  fbData?.bonus?.points
                                )
                              : "cash"
                            : pluralize(
                                pointsBranding?.active
                                  ? pointsBranding?.name
                                  : "Pts",
                                fbData?.bonus?.points
                              )}
                        </span>{" "}
                        on giving feedback
                      </h3>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className={`questions-card`}>
                    {activeRating === 4 || activeRating === 5 ? (
                      <h4>{fbData?.questions?.followup?.positive}</h4>
                    ) : (
                      <></>
                    )}
                    {activeRating > 0 && activeRating < 4 ? (
                      <h4>
                        {fbData?.questions?.followup?.negative ||
                          fbData?.questions?.followup?.neutral}
                      </h4>
                    ) : (
                      <></>
                    )}
                    {fbData?.category_options?.map(
                      (category) =>
                        category.active && (
                          <div
                            key={category.name}
                            onClick={() => handleCategoryClick(category)}
                            className={`category${
                              selectedCategories.some(
                                (cat) => cat.name === category.name
                              )
                                ? " selectedCategory"
                                : ""
                            }`}
                          >
                            <h6>{category.name}</h6>
                            {selectedCategories.some(
                              (cat) => cat.name === category.name
                            ) ? (
                              <img
                                alt="selected"
                                src="/assets/icons/check-dark-green.svg"
                              />
                            ) : (
                              <></>
                            )}
                          </div>
                        )
                    )}
                    <h4 style={{ margin: "24px 0 8px", textAlign: "left" }}>
                      Describe your experience (optional)
                    </h4>
                    <textarea
                      value={textFb}
                      className="primary-textarea"
                      placeholder="Add your comment"
                      onChange={(e) => setTextFb(e.target.value)}
                    ></textarea>
                  </div>
                  <PrimaryBtn
                    width="100%"
                    radius="10px"
                    height="45px"
                    type="submit"
                    disabled={isSubmitFirstStep}
                    isSubmitting={isSubmitFirstStep}
                    txtcolor={loyaltyData?.colors?.text || fbData?.colors?.text}
                    btnColor={
                      loyaltyData?.colors?.theme || fbData?.colors?.theme
                    }
                    text={fbData?.hear_about_us?.status ? "Next" : "Submit"}
                    handleClick={() => {
                      if (selectedCategories?.length === 0) {
                        toastr.error(
                          "Error",
                          "Please select atleast one reason for rating."
                        );
                      } else {
                        setSubmittingFirstStep(true);
                        dispatch(
                          updateFeedBackDets(storeId, txnData?.id, {
                            answer: textFb,
                            score: activeRating,
                            category_options: selectedCategories?.map(
                              (item) => item.name
                            ),
                          })
                        )
                          .then(() => {
                            setSubmittingFirstStep(false);
                            if (
                              fbData?.hear_about_us?.status &&
                              hear_about_us_flag
                            ) {
                              setActiveStep(1);
                            } else {
                              setActiveStep(2);
                            }
                          })
                          .catch(() => setSubmittingFirstStep(false));
                      }
                    }}
                  />
                </>
              )}
            </div>
          )}

          {fbData?.hear_about_us?.status && activeStep === 1 && (
            <div className={`questions-card`}>
              <h4 style={{ textAlign: "left" }}>How did you hear about us?</h4>
              {isSubmitSecondStep ? (
                <Loading />
              ) : (
                fbData?.hear_about_us?.sources.map(
                  (item) =>
                    item.active && (
                      <div
                        key={item.name}
                        onClick={() => handleVisitedFromClick(item)}
                        className={`category${
                          selectedVisitedFrms.some(
                            (visitFrm) => visitFrm.name === item.name
                          )
                            ? " selectedCategory"
                            : ""
                        }`}
                      >
                        <h6>{item.name}</h6>
                        {selectedVisitedFrms.some(
                          (visitFrm) => visitFrm.name === item.name
                        ) ? (
                          <img
                            alt="selected"
                            src="/assets/icons/check-dark-green.svg"
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    )
                )
              )}
            </div>
          )}

          {activeStep === 2 && (
            <>
              <div className="success-card">
                <img
                  alt="success"
                  className="success-img"
                  src="/assets/images/feedback/success-2.svg"
                />
                {activeRating > 3 ? (
                  <h3>
                    Thanks for your wonderful feedback,
                    <br />
                    We're glad that you like it.
                  </h3>
                ) : (
                  <h3>Thank you for your valuable feedback.</h3>
                )}
              </div>
              {isOnlineReviewActive &&
                activeRating >= minRatingForReview &&
                shortCode !== localStorage?.review_short_code_2 &&
                reviewShortCode !== localStorage.review_short_code && (
                  <div className="online_review">
                    <p>
                      Do us a favour and{" "}
                      <span>share your rating on {reviewPlatform}</span> too? It
                      takes 2 sec.
                    </p>
                    {textFb?.length?.length > 0 && (
                      <PrimaryBtn
                        width="100%"
                        height="40px"
                        btnColor="#ffffff"
                        txtcolor="#6B2AC1"
                        text="Copy Your Comment"
                        handleClick={handleCopy}
                      />
                    )}
                    <PrimaryBtn
                      width="100%"
                      height="40px"
                      txtColor="#ffffff"
                      btnColor="#6B2AC1"
                      text={`Leave Online Review `}
                      icon="/assets/icons/right-purple-arrow.svg"
                      handleClick={() => {
                        toggleModal();
                        localStorage.setItem("review_short_code_2", shortCode);
                        redirectToDifferentPage(
                          reviewShortCode?.length > 0
                            ? `${hostName}/${reviewShortCode}${
                                txnData?.txn?.type === "test"
                                  ? "?test=true"
                                  : ""
                              }`
                            : reviewDirectLink // This is for test feedback
                        );
                      }}
                    />
                    <img
                      alt="star-1"
                      className="star-1"
                      src="/assets/images/feedback/online_review_star_1.svg"
                    />
                    <img
                      alt="star-2"
                      className="star-2"
                      src="/assets/images/feedback/online_review_star_2.svg"
                    />
                  </div>
                )}
              <PrimaryBtn
                width="100%"
                radius="10px"
                height="40px"
                text={"Back to home"}
                handleClick={toggleModal}
                txtcolor={loyaltyData?.colors?.text || fbData?.colors?.text}
                btnColor={loyaltyData?.colors?.theme || fbData?.colors?.theme}
              />
            </>
          )}
        </div>
      </div>
    </Offcanvas>
  );
};

export default FeedbackModal;

const emojiIcons = [
  "/assets/images/feedback/emoji/emoji_1.svg",
  "/assets/images/feedback/emoji/emoji_2.svg",
  "/assets/images/feedback/emoji/emoji_3.svg",
  "/assets/images/feedback/emoji/emoji_4.svg",
  "/assets/images/feedback/emoji/emoji_5.svg",
];

const scoreIcons = [
  "/assets/icons/digits/digit_1.svg",
  "/assets/icons/digits/digit_2.svg",
  "/assets/icons/digits/digit_3.svg",
  "/assets/icons/digits/digit_4.svg",
  "/assets/icons/digits/digit_5.svg",
];
